import { redirect } from "react-router-dom";

export const roleGuard = () => {
    if (localStorage.getItem("coach_token") === null) return redirect("/login")
    return redirect("/")
}